// Model
import { ApiResponse } from './../models/api-response.model';
// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadHttpService {
  static uploadedFile = null;
  static uploadedFileForm = null;
  constructor(private http: HttpClient) { }

  upload(data: any): Observable<[]> {
    return this.http.post<ApiResponse>('/file', data).pipe(
      map(res => res.data.files)
    );
  }
}
